import React, { useEffect, useState } from "react";
import axios from "axios";
import styled from "styled-components";

const Container = styled.div`
  width: 100%;
//   min-height: 100vh;
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  background: #f5f6fa;
  @media(max-width:576px){
    padding:5px;
  }
`;

const Card = styled.div`
  width: 100%;
  max-width: 400px;
  background: white;
  padding: 25px;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);

  @media (max-width: 600px) {
    padding: 18px;
  }
`;

const Title = styled.h2`
  text-align: center;
  margin-bottom: 20px;
`;

const Form = styled.form`
  display: grid;
  grid-template-columns: 1fr;
  gap: 15px;
`;

const Input = styled.input`
  padding: 12px;
  border-radius: 6px;
  border: 1px solid #ddd;
  font-size: 14px;
  width: 100%;

  &:focus {
    outline: none;
    border-color: #007bff;
  }
`;

const Button = styled.button`
  padding: 12px;
  border: none;
  border-radius: 6px;
  background: #ef4766;
  color: white;
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s;

  &:hover {
    background: #c50528;
  }
`;

const DetailRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  border-bottom: 1px solid #eee;
  padding-bottom: 8px;

  span:first-child {
    font-weight: 600;
  }

  @media (max-width: 500px) {
    flex-direction: column;
    gap: 3px;
  }
`;

const MerchantAccountDetails = () => {
  const [merchantId, setMerchantId] = useState(null);
  const [hasData, setHasData] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  const [formData, setFormData] = useState({
    merchantId: 0,
    accountHolderName: "",
    bankName: "",
    accountNumber: "",
    ifscCode: "",
    branchName: "",
    upiId: ""
  });

  useEffect(() => {
    const login = localStorage.getItem("merchantLogin");

    if (login) {
      const parsed = JSON.parse(login);
      const id = parsed.merchantId || parsed.id;
      setMerchantId(id);
      fetchDetails(id);
    }
  }, []);
  useEffect(() => {
    const login = localStorage.getItem("merchantLogin");

    if (login) {
      const parsed = JSON.parse(login);
      const id = parsed.merchantId || parsed.id;
      setMerchantId(id);
      fetchDetails(id);
    }
  }, [isEditing]);

  const fetchDetails = async (id) => {
    try {
      const res = await axios.get(
        `https://api.bakpoket.com/api/MerchantDetails/Merchantbankdetails/${id}`
      );

      if (res.data && res.data.accountHolderName) {
        setFormData(res.data);
        setHasData(true);
      }
    } catch (err) {
      setHasData(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      merchantId: merchantId,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (hasData) {
        await axios.put(
          `https://api.bakpoket.com/api/MerchantDetails/Merchantbankedit/${formData.id}`,
          formData
        );
        alert("Bank details updated");
        setIsEditing(false);
      } else {
        await axios.post(
          "https://api.bakpoket.com/api/MerchantDetails/Merchantbankadd",
          formData
        );
        alert("Bank details added");
        setHasData(true);
      }
    } catch (error) {
      alert("Something went wrong");
    }
  };


  

  return (
    <Container>
      <Card>
        <Title>Merchant Bank Details</Title>

        {hasData && !isEditing ? (
          <>
            <DetailRow>
              <span>Account Holder</span>
              <span>{formData.accountHolderName}</span>
            </DetailRow>

            <DetailRow>
              <span>Bank Name</span>
              <span>{formData.bankName}</span>
            </DetailRow>

            <DetailRow>
              <span>Account Number</span>
              <span>{formData.accountNumber}</span>
            </DetailRow>

            <DetailRow>
              <span>IFSC Code</span>
              <span>{formData.ifscCode}</span>
            </DetailRow>

            <DetailRow>
              <span>Branch</span>
              <span>{formData.branchName}</span>
            </DetailRow>

            <DetailRow>
              <span>UPI ID</span>
              <span>{formData.upiId}</span>
            </DetailRow>

            <Button onClick={() => setIsEditing(true)}>
              Update Details
            </Button>
          </>
        ) : (
          <Form onSubmit={handleSubmit}>
            <Input
              name="accountHolderName"
              placeholder="Account Holder Name"
              value={formData.accountHolderName}
              onChange={handleChange}
              required
            />

            <Input
              name="bankName"
              placeholder="Bank Name"
              value={formData.bankName}
              onChange={handleChange}
              required
            />

            <Input
              name="accountNumber"
              placeholder="Account Number"
              value={formData.accountNumber}
              onChange={handleChange}
              required
            />

            <Input
              name="ifscCode"
              placeholder="IFSC Code"
              value={formData.ifscCode}
              onChange={handleChange}
              required
            />

            <Input
              name="branchName"
              placeholder="Branch Name"
              value={formData.branchName}
              onChange={handleChange}
            />

            <Input
              name="upiId"
              placeholder="UPI ID"
              value={formData.upiId}
              onChange={handleChange}
            />

            <Button type="submit">
              {hasData ? "Update Details" : "Save Details"}
            </Button>
            {hasData ? 
            <Button type="button" onClick={()=>setIsEditing(false)}>
              Cancel
            </Button>
            : null}
          </Form>
        )}
      </Card>
    </Container>
  );
};

export default MerchantAccountDetails;